import React from "react";
import { useChipValue } from "./ChipValue.hooks.js";
const withChipTooltip = (WrappedComponent) => (props) => {
  const { chipLabel } = useChipValue(props.value, props.chipName, props.label);
  return /* @__PURE__ */ React.createElement(WrappedComponent, { tooltipLabel: chipLabel, ...props });
};
const withLabelChipTooltip = (WrappedComponent) => (props) => {
  return /* @__PURE__ */ React.createElement(WrappedComponent, { tooltipLabel: props.value, ...props });
};
export {
  withChipTooltip,
  withLabelChipTooltip
};
//# sourceMappingURL=ChipTooltipHoc.js.map
